import React from "react";
import { useSelector } from "react-redux";

import {
  ExperienceListVariationDto,
  GenericExperienceFe,
} from "@intelligems/ig-types";
import DownloadPriceCsvDialog from "@src/features/experiments/components/dialogs/DownloadPriceCsvDialog";
import { EndNonPriceTestDialog } from "@src/features/experiments/components/dialogs/EndNonPriceTestDialog";
import { MarketPriceUpdaterDialog } from "@src/features/experiments/components/dialogs/MarketPriceUpdaterDialog";
import { MarketPriceUpdaterStartDialog } from "@src/features/experiments/components/dialogs/MarketPriceUpdaterStartDialog";
import { MarketUpdateConfirmDialog } from "@src/features/experiments/components/dialogs/MarketUpdateConfirmDialog";
import { PriceUpdaterDialog } from "@src/features/experiments/components/dialogs/PriceUpdaterDialog";
import { ShippingRatesDialog } from "@src/features/experiments/components/dialogs/ShippingRatesDialog";
import { StartPriceTestDialog } from "@src/features/experiments/components/dialogs/StartPriceTestDialog";
import { RolloutsDialog } from "@src/features/sharedExperience/components/rollouts/components/RolloutsDialog";
import { isDialogOpen } from "@src/store/slices/global";

interface GroupedActionExperienceDialogsProps {
  experience: GenericExperienceFe;
  variations: (Omit<ExperienceListVariationDto, "experienceId"> & {
    experienceId?: string;
  })[];
  isExperienceRender: boolean;
  noRedirect?: boolean;
}

export const GroupedActionExperienceDialogs = ({
  experience,
  variations,
  noRedirect,
  isExperienceRender,
}: GroupedActionExperienceDialogsProps) => {
  const isMarketPriceUpdaterDialogOpen = useSelector(
    isDialogOpen("marketPriceUpdater")
  );
  const isMarketPriceUpdaterConfirmDialogOpen = useSelector(
    isDialogOpen("marketUpdateConfirm")
  );
  const isRolloutsDialogOpen = useSelector(isDialogOpen("rollouts"));
  const isPriceUpdaterDialogOpen = useSelector(isDialogOpen("priceUpdater"));
  const isMarketPriceUpdaterStartOpen = useSelector(
    isDialogOpen("marketPriceUpdaterStart")
  );

  return (
    <>
      {isPriceUpdaterDialogOpen && (
        <PriceUpdaterDialog
          noRedirect={noRedirect ?? false}
          currExperience={experience}
          variations={variations}
        />
      )}
      <StartPriceTestDialog experience={experience} />
      <EndNonPriceTestDialog experience={experience} />
      {isMarketPriceUpdaterStartOpen && (
        <MarketPriceUpdaterStartDialog currExperience={experience} />
      )}
      <DownloadPriceCsvDialog
        currentExperience={experience}
        variations={variations}
      />
      <ShippingRatesDialog currExperience={experience} />
      {isMarketPriceUpdaterDialogOpen && (
        <MarketPriceUpdaterDialog
          variations={variations}
          currExperience={experience}
        />
      )}
      {isMarketPriceUpdaterConfirmDialogOpen && (
        <MarketUpdateConfirmDialog currExperience={experience} />
      )}
      {isRolloutsDialogOpen && (
        <RolloutsDialog
          experience={experience}
          variations={variations}
          isExperienceRender={isExperienceRender}
        />
      )}
    </>
  );
};
